export class DescriptionListTitleStyle {
  size = '';
  font = 'tb-font-primary';
  color = 'uk-color-black';

  static normalize(styles: Partial<DescriptionListTitleStyle>): DescriptionListTitleStyle {
    const pureStyles = new DescriptionListTitleStyle();

    pureStyles.size = styles.size ?? pureStyles.size;
    pureStyles.font = styles.font ?? pureStyles.font;
    pureStyles.color = styles.color ?? pureStyles.color;

    return pureStyles;
  }
}
